import { accordionClasses, accordionSummaryClasses } from '@mui/material'
import { type ComponentsOverrides, type Theme } from '@mui/material/styles'
import { rem } from 'polished'

export const overridesAccordion = (): ComponentsOverrides['MuiAccordion'] => ({
  root: {
    [`&.${accordionClasses.expanded}`]: {
      margin: 0,
    },
    [`&.${accordionClasses.root}::before`]: {
      display: 'none',
    },
  },
  rounded: {
    borderRadius: 0,
  },
})

export const overridesAccordionSummary = (theme: Theme): ComponentsOverrides['MuiAccordionSummary'] => ({
  root: {
    padding: theme.spacing(2),
    // Minimal height without expanded icon
    minHeight: rem(56),
    [`&.${accordionSummaryClasses.expanded}`]: {
      // Minimal height without expanded icon
      minHeight: rem(56),
    },
  },
  content: {
    margin: 0,
    [`&.${accordionSummaryClasses.expanded}`]: {
      margin: 0,
    },
  },
  expandIconWrapper: {
    marginRight: `-${theme.spacing(2)}`,
    padding: theme.spacing('0', 2),
  },
})

export const overridesAccordionDetails = (): ComponentsOverrides['MuiAccordionDetails'] => ({
  root: {
    padding: 0,
  },
})
